import { config } from '@/config';

export const AML_REVIEW_REGIONS: readonly { label: string; code: string }[] = [
  { label: 'United Arab Emirates', code: 'AE' },
  { label: 'Armenia', code: 'AM' },
  { label: 'Antarctica', code: 'AQ' },
  { label: 'Argentina', code: 'AR' },
  { label: 'Austria', code: 'AT' },
  { label: 'Australia', code: 'AU' },
  { label: 'Azerbaijan', code: 'AZ' },
  { label: 'Belgium', code: 'BE' },
  { label: 'Bulgaria', code: 'BG' },
  { label: 'Bahrain', code: 'BH' },
  { label: 'Benin', code: 'BJ' },
  { label: 'Bolivia', code: 'BO' },
  { label: 'Brazil', code: 'BR' },
  { label: 'Bahamas', code: 'BS' },
  { label: 'Belarus', code: 'BY' },
  { label: 'Belize', code: 'BZ' },
  { label: 'Switzerland', code: 'CH' },
  { label: 'Chile', code: 'CL' },
  { label: 'Cameroon', code: 'CM' },
  { label: 'Colombia', code: 'CO' },
  { label: 'Costa Rica', code: 'CR' },
  { label: 'Cyprus', code: 'CY' },
  { label: 'Czech Republic', code: 'CZ' },
  { label: 'Germany', code: 'DE' },
  { label: 'Denmark', code: 'DK' },
  { label: 'Dominica', code: 'DM' },
  { label: 'Dominican Republic', code: 'DO' },
  { label: 'Ecuador', code: 'EC' },
  { label: 'Estonia', code: 'EE' },
  { label: 'Spain', code: 'ES' },
  { label: 'Finland', code: 'FI' },
  { label: 'France', code: 'FR' },
  { label: 'United Kingdom', code: 'GB' },
  { label: 'Grenada', code: 'GD' },
  { label: 'Georgia', code: 'GE' },
  { label: 'Ghana', code: 'GH' },
  { label: 'Greece', code: 'GR' },
  { label: 'Guatemala', code: 'GT' },
  { label: 'Honduras', code: 'HN' },
  { label: 'Croatia', code: 'HR' },
  { label: 'Hungary', code: 'HU' },
  { label: 'Ireland', code: 'IE' },
  { label: 'Israel', code: 'IL' },
  { label: 'Iceland', code: 'IS' },
  { label: 'Italy', code: 'IT' },
  { label: 'Jordan', code: 'JO' },
  { label: 'Japan', code: 'JP' },
  { label: 'Kyrgyzstan', code: 'KG' },
  { label: 'South Korea', code: 'KR' },
  { label: 'Kuwait', code: 'KW' },
  { label: 'Kazakhstan', code: 'KZ' },
  { label: 'Lebanon', code: 'LB' },
  { label: 'Liechtenstein', code: 'LI' },
  { label: 'Lithuania', code: 'LT' },
  { label: 'Luxembourg', code: 'LU' },
  { label: 'Latvia', code: 'LV' },
  { label: 'Malta', code: 'MT' },
  { label: 'Mexico', code: 'MX' },
  { label: 'Malaysia', code: 'MY' },
  { label: 'Netherlands', code: 'NL' },
  { label: 'Norway', code: 'NO' },
  { label: 'New Zealand', code: 'NZ' },
  { label: 'Oman', code: 'OM' },
  { label: 'Panama', code: 'PA' },
  { label: 'Peru', code: 'PE' },
  { label: 'Pakistan', code: 'PK' },
  { label: 'Poland', code: 'PL' },
  { label: 'Portugal', code: 'PT' },
  { label: 'Paraguay', code: 'PY' },
  { label: 'Romania', code: 'RO' },
  { label: 'Rwanda', code: 'RW' },
  { label: 'Saudi Arabia', code: 'SA' },
  { label: 'Sweden', code: 'SE' },
  { label: 'Slovenia', code: 'SI' },
  { label: 'Slovakia', code: 'SK' },
  { label: 'El Salvador', code: 'SV' },
  { label: 'Thailand', code: 'TH' },
  { label: 'Tajikistan', code: 'TJ' },
  { label: 'Trinidad and Tobago', code: 'TT' },
  { label: 'Taiwan', code: 'TW' },
  { label: 'Tanzania', code: 'TZ' },
  { label: 'Ukraine', code: 'UA' },
  { label: 'Uruguay', code: 'UY' },
  { label: 'Uzbekistan', code: 'UZ' },
  { label: 'Venezuela', code: 'VE' },
  { label: 'Vietnam', code: 'VN' },
  { label: 'South Africa', code: 'ZA' },
];

const PROD_LIVE_PARTNERS: readonly { label: string; accountId: string }[] = [
  { label: 'Binance', accountId: '0b5cf383ffc317340d5f96dc6df9d3b6' },
  { label: 'Bitget Wallet', accountId: 'bcbc0e3121ed19bfae2c486b828b1dd9' },
  { label: 'HanaWallet', accountId: 'dcd1fb665243de2faeca2c442fba52d1' },
  { label: 'Immersve', accountId: '88a100694babaa263f0863135bb4e501' },
  { label: 'KuCoin', accountId: '509549a702ff10d3480644d059bf8f88' },
  { label: 'MetaMask', accountId: '3c4deee311f7636ad291a50ed8f75210' },
  { label: 'MoonPay', accountId: '2280bb0dca103d5ea3d35ca1b7f38263' },
  { label: 'PayItNow', accountId: 'a77bbc6555ef43a5f203131a84f80288' },
  { label: 'SpendTheBits', accountId: '3ce746cb2ffe3e03763f4f6b70921f55' },
  { label: 'Vield', accountId: '5f1129423e85fff9635ab918afaf815c' },
];

const PROD_TEST_PARTNERS: readonly { label: string; accountId: string }[] = [
  { label: 'Binance', accountId: '51fd2ddaa712107f0439137ec2f72263' },
  { label: 'Bitget Wallet', accountId: 'ad1b60dd974ab5ffcda95129548c7f6d' },
  { label: 'HanaWallet', accountId: '80d60a07e9b0c6cfab6a50edbe6dd28e' },
  { label: 'Immersve', accountId: '9563d92269c3e0b8876b0a073048be43' },
  { label: 'KuCoin', accountId: '658a73ebd140c8167af0a35489723180' },
  { label: 'MetaMask', accountId: '539a7dae231e578d0da0e293d110d08d' },
  { label: 'MoonPay', accountId: 'e92b62db4ffe2ce5d2a912b30387130c' },
  { label: 'PayItNow', accountId: '5bee9a8b77dac5601acafde20f3e8835' },
  { label: 'Vield', accountId: 'f1cb0e9ca75cdb06a5c1c36ed3e9e6fa' },
];

const DEV_LIVE_PARTNERS: readonly { label: string; accountId: string }[] = [
  { label: 'Immersve (dev)', accountId: '2d4aec21adf5c3251d6f868accf94791' },
];

export const AML_REVIEW_PARTNERS: readonly { label: string; accountId: string }[] =
  config.env === 'prod'
    ? config.testModeEnabled
      ? PROD_TEST_PARTNERS
      : PROD_LIVE_PARTNERS
    : config.testModeEnabled
      ? []
      : DEV_LIVE_PARTNERS;

export const AML_REVIEW_PROVIDERS: readonly { label: string; value: string }[] = [
  { label: 'FrankieOne', value: 'frankieOne' },
  { label: 'Sumsub', value: 'sumsub' },
];

// Relative windows rather than a raw datetime picker — hours is undefined for
// 'all' (no since filter sent). Likely to change as usage settles; 'all' is
// the default for now.
export const AML_REVIEW_SINCE_OPTIONS: readonly {
  label: string;
  value: string;
  hours?: number;
}[] = [
  { label: 'All time', value: 'all' },
  { label: 'Last hour', value: '1h', hours: 1 },
  { label: 'Last 8 hours', value: '8h', hours: 8 },
  { label: 'Last 12 hours', value: '12h', hours: 12 },
  { label: 'Last 24 hours', value: '24h', hours: 24 },
  { label: 'Last 3 days', value: '3d', hours: 72 },
  { label: 'Last week', value: '7d', hours: 168 },
];
